var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 189 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__a",
    x1: 28.163,
    y1: 12.194,
    x2: 13.273,
    y2: 26.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__b",
    x1: 48.949,
    y1: 27.901,
    x2: 17.403,
    y2: 27.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__c",
    x1: 37.217,
    y1: 33.5,
    x2: 11.999,
    y2: 56.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__d",
    x1: 14.376,
    y1: 8.084,
    x2: 25.616,
    y2: 18.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__e",
    x1: 37.206,
    y1: 37.512,
    x2: 16.999,
    y2: 56.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__f",
    x1: 19.992,
    y1: 12.194,
    x2: 6.874,
    y2: 24.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__g",
    x1: 48.949,
    y1: 28.002,
    x2: 17.403,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__h",
    x1: 48.949,
    y1: 28.002,
    x2: 17.403,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__i",
    x1: 19.979,
    y1: 12.217,
    x2: 7.383,
    y2: 23.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__j",
    x1: 14.352,
    y1: 11.752,
    x2: 23.375,
    y2: 20.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "google_svg__bg",
    d: "M182 56H7c-3.85 0-7-3.15-7-7V7c0-3.85 3.15-7 7-7h175c3.85 0 7 3.15 7 7v42c0 3.85-3.15 7-7 7",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182 0H7C3.15 0 0 3.15 0 7v42c0 3.85 3.15 7 7 7h175c3.85 0 7-3.15 7-7V7c0-3.85-3.15-7-7-7m0 1.12A5.887 5.887 0 0 1 187.88 7v42a5.887 5.887 0 0 1-5.88 5.88H7A5.887 5.887 0 0 1 1.12 49V7A5.887 5.887 0 0 1 7 1.12h175",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "google_svg__text",
    d: "M67.673 14.34c0 1.174-.323 2.108-.971 2.805-.736.828-1.695 1.243-2.874 1.243-1.129 0-2.089-.42-2.878-1.262-.79-.84-1.186-1.882-1.186-3.126s.395-2.286 1.186-3.127c.79-.84 1.75-1.261 2.878-1.261.56 0 1.097.117 1.606.352.51.235.918.547 1.223.938l-.687.74c-.518-.665-1.231-.997-2.142-.997-.823 0-1.535.31-2.136.932-.601.623-.901 1.43-.901 2.423 0 .993.3 1.8.901 2.423.6.622 1.313.932 2.136.932.874 0 1.602-.312 2.185-.938.378-.407.597-.974.656-1.701h-2.84v-1.01h3.79c.036.22.054.43.054.635",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "google_svg__text",
    d: "M67.673 14.34h-.13c-.001 1.147-.313 2.037-.933 2.706h-.002v.002c-.713.8-1.628 1.198-2.78 1.2-1.099-.002-2.019-.405-2.787-1.22-.766-.818-1.145-1.816-1.146-3.028.001-1.212.38-2.21 1.146-3.027.769-.816 1.688-1.22 2.787-1.221.544 0 1.061.114 1.554.34.494.23.885.529 1.175.9l.1-.09-.092-.098-.688.739.093.098.1-.09c-.542-.697-1.303-1.048-2.242-1.046-.854-.001-1.605.326-2.226.972-.628.647-.943 1.5-.942 2.523 0 1.023.314 1.876.942 2.523.621.646 1.372.973 2.226.972.903.002 1.672-.327 2.277-.979.404-.435.634-1.038.694-1.788l.012-.152h-2.853v-.73h3.66v-.14l-.128.026c.036.212.053.414.053.609h.26c0-.213-.018-.432-.056-.66l-.02-.114h-4.03v1.289h2.972v-.14l-.13-.012c-.058.704-.266 1.235-.618 1.614-.56.6-1.248.895-2.093.897-.793-.001-1.465-.294-2.045-.893-.575-.597-.86-1.358-.862-2.322.001-.964.287-1.725.862-2.322.58-.599 1.252-.892 2.045-.893.882.002 1.547.315 2.042.947l.092.117.787-.848.085-.09-.077-.098a3.368 3.368 0 0 0-1.272-.977 3.92 3.92 0 0 0-1.657-.364c-1.159-.001-2.159.436-2.97 1.302-.815.864-1.225 1.95-1.224 3.226-.001 1.275.41 2.362 1.224 3.227.811.865 1.811 1.302 2.97 1.3 1.207.002 2.208-.429 2.968-1.286l-.094-.096.092.099c.675-.725 1.01-1.704 1.01-2.903h-.13m6.008-3.51H70.12v2.664h3.213v1.01H70.12v2.663h3.562V18.2h-4.566V9.8h4.566v1.032",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "google_svg__text",
    d: "M73.682 10.832v-.14H69.99v2.943h3.212v.73H69.99v2.943h3.562v.752h-4.306V9.94h4.306v.892h.13v-.14.14h.13V9.66h-4.826v8.68h4.827v-1.312H70.25v-2.383h3.213v-1.29h-3.212v-2.383h3.562v-.14h-.13M77.92 18.2h-1.006v-7.368H74.73V9.8h5.376v1.032H77.92V18.2",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "google_svg__text",
    d: "M77.921 18.2v-.14h-.876v-7.368h-2.184V9.94h5.114v.752h-2.184V18.2h.13v-.14.14h.13v-7.228h2.185V9.66H74.6v1.312h2.185v7.368h1.266v-.14h-.13m6.074 0V9.8H85v8.4h-1.005",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "google_svg__text",
    d: "M83.995 18.2h.13V9.94h.744v8.12h-.874v.14h.13-.13v.14h1.135V9.66h-1.265v8.68h.13v-.14m5.463 0h-1.005v-7.368h-2.185V9.8h5.375v1.032h-2.185V18.2",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "google_svg__text",
    d: "M89.458 18.2v-.14h-.875v-7.368h-2.185V9.94h5.115v.752h-2.185V18.2h.13v-.14.14h.13v-7.228h2.185V9.66h-5.635v1.312h2.184v7.368h1.267v-.14h-.13m7.366-1.789c.58.63 1.288.944 2.125.944.838 0 1.547-.314 2.125-.944.58-.63.87-1.434.87-2.411 0-.977-.29-1.782-.87-2.411-.578-.63-1.287-.944-2.125-.944-.837 0-1.546.314-2.125.944-.578.63-.868 1.434-.868 2.411 0 .977.29 1.782.868 2.411Zm4.994.703c-.77.85-1.726 1.274-2.869 1.274-1.144 0-2.1-.424-2.867-1.274-.77-.848-1.152-1.886-1.152-3.114s.383-2.266 1.152-3.114c.768-.85 1.724-1.274 2.867-1.274 1.137 0 2.091.426 2.863 1.279.772.853 1.158 1.889 1.158 3.109 0 1.228-.385 2.266-1.152 3.114Z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "google_svg__text",
    d: "m96.825 16.411-.093.099c.601.654 1.35.987 2.218.985.868.002 1.618-.33 2.218-.985.604-.656.908-1.503.907-2.51.001-1.007-.303-1.854-.907-2.51-.6-.654-1.35-.987-2.218-.985-.868-.002-1.617.33-2.218.985-.602.656-.907 1.503-.905 2.51-.002 1.007.303 1.854.906 2.51l.092-.099.093-.098c-.553-.605-.83-1.365-.83-2.313 0-.948.277-1.708.83-2.313.558-.604 1.225-.9 2.032-.902.807.002 1.476.298 2.032.902.554.605.831 1.365.832 2.313-.001.948-.278 1.708-.832 2.313-.556.604-1.224.9-2.032.902-.807-.002-1.474-.298-2.032-.902l-.093.098Zm4.993.703-.093-.097c-.747.823-1.661 1.229-2.775 1.23-1.113-.001-2.028-.407-2.774-1.23l-.003-.004.003.004c-.746-.825-1.114-1.82-1.115-3.017.001-1.197.37-2.192 1.115-3.017.746-.823 1.66-1.23 2.774-1.231 1.106.002 2.018.41 2.77 1.237.749.829 1.119 1.823 1.121 3.011-.002 1.197-.371 2.192-1.116 3.017l.093.097.094.098c.791-.872 1.19-1.953 1.189-3.212.001-1.252-.4-2.33-1.194-3.206-.794-.88-1.789-1.324-2.957-1.322-1.173-.002-2.171.44-2.96 1.316-.792.872-1.19 1.953-1.19 3.212 0 1.259.398 2.34 1.19 3.212l.003.004-.003-.004c.789.875 1.787 1.317 2.96 1.316 1.173 0 2.171-.44 2.962-1.316l-.094-.098Zm2.564 1.086V9.8h1.223l3.801 6.535h.044l-.044-1.62V9.8h1.006v8.4h-1.049l-3.977-6.851h-.043l.043 1.619V18.2h-1.004",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "google_svg__text",
    d: "M104.382 18.2h.13V9.94h1.021l3.801 6.535h.25l-.047-1.761V9.94h.745v8.12h-.846l-3.978-6.851h-.249l.046 1.761v5.09h-.873v.14h.13-.13v.14h1.134v-5.374l-.043-1.621-.13.004v.14h.043v-.14l-.111.074 4.016 6.917h1.252V9.66h-1.267v5.057l.043 1.621.131-.003v-.14h-.044v.14l.111-.075-3.84-6.6h-1.426v8.68h.131v-.14M145.267 42h2.432V24.498h-2.432V42Zm21.911-11.197-2.789 7.588h-.083l-2.894-7.588h-2.621l4.34 10.605-2.474 5.9h2.538l6.688-16.505h-2.705Zm-13.796 9.21c-.798 0-1.908-.428-1.908-1.487 0-1.351 1.384-1.869 2.578-1.869 1.071 0 1.573.248 2.223.586-.189 1.62-1.489 2.77-2.893 2.77Zm.293-9.593c-1.761 0-3.585.833-4.34 2.68l2.159.968c.462-.968 1.321-1.284 2.223-1.284 1.258 0 2.537.811 2.558 2.252v.18c-.441-.27-1.383-.675-2.537-.675-2.327 0-4.697 1.373-4.697 3.94 0 2.342 1.908 3.85 4.046 3.85 1.637 0 2.538-.788 3.105-1.71h.083v1.35h2.348v-6.71c0-3.107-2.159-4.841-4.948-4.841Zm-15.034 2.513h-3.46v-5.999h3.46c1.819 0 2.851 1.617 2.851 3 0 1.356-1.032 3-2.851 3Zm-.062-8.435h-5.829V42h2.431v-6.63h3.398c2.696 0 5.346-2.097 5.346-5.436 0-3.34-2.65-5.436-5.346-5.436Zm-31.786 15.517c-1.681 0-3.088-1.51-3.088-3.586 0-2.097 1.407-3.631 3.088-3.631 1.659 0 2.961 1.534 2.961 3.631 0 2.075-1.302 3.586-2.961 3.586Zm2.793-8.232h-.084c-.546-.7-1.596-1.33-2.919-1.33-2.773 0-5.314 2.616-5.314 5.976 0 3.338 2.541 5.932 5.314 5.932 1.323 0 2.373-.632 2.919-1.353h.084v.857c0 2.278-1.134 3.496-2.961 3.496-1.491 0-2.415-1.15-2.794-2.12l-2.121.947c.609 1.579 2.227 3.519 4.915 3.519 2.856 0 5.272-1.805 5.272-6.203v-10.69h-2.311v.969ZM113.577 42h2.436V24.498h-2.436V42Zm6.028-5.774c-.063-2.3 1.659-3.473 2.898-3.473.967 0 1.786.518 2.058 1.263l-4.956 2.21Zm7.561-1.984c-.462-1.332-1.87-3.79-4.747-3.79-2.856 0-5.23 2.414-5.23 5.955 0 3.338 2.353 5.954 5.503 5.954 2.542 0 4.012-1.67 4.621-2.639l-1.89-1.353c-.63.992-1.492 1.646-2.731 1.646-1.239 0-2.121-.609-2.688-1.804l7.414-3.293-.252-.676Zm-59.069-1.963v2.526h5.63c-.169 1.421-.61 2.459-1.282 3.18-.819.88-2.1 1.85-4.348 1.85-3.465 0-6.174-3-6.174-6.721 0-3.722 2.709-6.722 6.174-6.722 1.87 0 3.235.79 4.243 1.805L74 26.415c-1.408-1.444-3.277-2.549-5.903-2.549-4.746 0-8.737 4.15-8.737 9.248 0 5.097 3.99 9.247 8.737 9.247 2.563 0 4.495-.902 6.007-2.594 1.554-1.669 2.038-4.015 2.038-5.909 0-.587-.042-1.127-.127-1.579h-7.918Zm14.444 7.736c-1.68 0-3.13-1.488-3.13-3.608 0-2.143 1.45-3.61 3.13-3.61s3.13 1.467 3.13 3.61c0 2.12-1.45 3.608-3.13 3.608Zm0-9.563c-3.067 0-5.566 2.504-5.566 5.955 0 3.428 2.5 5.954 5.566 5.954s5.566-2.526 5.566-5.954c0-3.451-2.5-5.955-5.566-5.955Zm12.142 9.563c-1.68 0-3.13-1.488-3.13-3.608 0-2.143 1.45-3.61 3.13-3.61s3.13 1.467 3.13 3.61c0 2.12-1.45 3.608-3.13 3.608Zm0-9.563c-3.067 0-5.566 2.504-5.566 5.955 0 3.428 2.499 5.954 5.566 5.954 3.066 0 5.566-2.526 5.566-5.954 0-3.451-2.5-5.955-5.566-5.955Z",
    fill: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.539 10.656c-.438.424-.699 1.13-.699 2.07v-.213 30.97-.204c0 .866.224 1.536.603 1.967l.097.1c.307.297.701.455 1.152.455.441 0 .937-.151 1.46-.47l18.924-11.546 6.5-3.967c.826-.503 1.29-1.153 1.367-1.815v-.002c-.078-.664-.541-1.313-1.367-1.817l-6.5-3.966-18.923-11.546c-.525-.32-1.021-.47-1.463-.47-.451 0-.844.157-1.151.454Z",
    fill: "#00C1FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m18.54 45.345-.097-.1c-.379-.43-.603-1.1-.603-1.966v.204V12.52v.204c0-.938.261-1.645.699-2.07L34.69 28.002l-16.15 17.344Z",
    fill: "url(#google_svg__a)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.076 33.785 34.691 28l5.385-5.783 6.5 3.966c.826.504 1.29 1.153 1.367 1.817v.002c-.078.662-.541 1.312-1.367 1.815l-6.5 3.967",
    fill: "url(#google_svg__b)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.692 45.8a1.61 1.61 0 0 1-1.152-.454L34.691 28l5.385 5.784L21.153 45.33c-.524.319-1.02.47-1.46.47Z",
    fill: "url(#google_svg__c)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.691 28.001 18.54 10.656c.307-.297.7-.455 1.15-.455.443 0 .94.152 1.464.471l18.923 11.546-5.385 5.783",
    fill: "url(#google_svg__d)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.693 46.006c-.452 0-.846-.158-1.153-.456-.002 0-.003-.002-.004-.003l-.084-.088-.009-.01.097-.103c.307.297.701.455 1.152.455.441 0 .937-.151 1.46-.47l18.924-11.546.122.13-.123.075-18.922 11.545c-.477.29-.931.442-1.341.468l-.12.003",
    fill: "url(#google_svg__e)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.443 45.45c-.379-.431-.603-1.1-.603-1.967v-.204c0 .866.224 1.536.603 1.967l.097.1-.097.104",
    fill: "url(#google_svg__f)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m40.197 33.915-.12-.13 6.5-3.967c.825-.503 1.288-1.153 1.366-1.815 0 .243-.05.486-.15.722-.203.476-.608.927-1.217 1.298l-6.379 3.892",
    fill: "url(#google_svg__g)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.943 28c-.078-.663-.541-1.312-1.367-1.816l-6.5-3.966.121-.13 6.38 3.892c.91.556 1.365 1.288 1.366 2.02",
    fill: "url(#google_svg__h)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.84 12.725v-.214c0-.077.002-.152.006-.225v-.015c.04-.747.255-1.33.597-1.718l.096.103c-.438.424-.699 1.13-.699 2.07Z",
    fill: "url(#google_svg__i)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.076 22.218 21.153 10.672c-.525-.32-1.021-.47-1.463-.47-.451 0-.844.157-1.151.454l-.096-.103c.03-.034.061-.066.093-.098l.004-.003a1.612 1.612 0 0 1 1.14-.455h.01c.442 0 .938.151 1.463.47l19.044 11.62v.001l-.121.13",
    fill: "url(#google_svg__j)"
  })));
};

export default SvgGoogle;